var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('ValidationObserver', {
    ref: "officePmFormModal",
    staticClass: "d-contents",
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var validationFailed = _ref.failed;
        return [_c('b-modal', {
          attrs: {
            "id": "officeModalPmForm",
            "title": _vm.getTitle,
            "modal-class": _vm.customClass ? "".concat(_vm.customClass, " form-modal") : "form-modal",
            "cancel-title": "Cancel",
            "cancel-disabled": _vm.submitting,
            "ok-title": "Submit",
            "centered": true,
            "ok-disabled": !_vm.office || validationFailed || _vm.submitting || !_vm.hasOfficeChanged
          },
          on: {
            "cancel": _vm.handlePmFormCancel,
            "ok": _vm.handlePmFormOK,
            "show": _vm.loadOfficeVariable
          }
        }, [_vm.office ? _c('div', [_vm.form === 'website' ? _c('div', [_c('FormItemGroup', [_c('FormItem', {
          attrs: {
            "label": "Website",
            "disabled": _vm.submitting,
            "value": _vm.office.website
          },
          on: {
            "update:value": function updateValue($event) {
              return _vm.$set(_vm.office, "website", $event);
            }
          }
        })], 1), _c('FormItemGroup', [_c('FormItem', {
          attrs: {
            "label": "Vanity Url",
            "disabled": _vm.submitting,
            "value": _vm.office.vanityUrl
          },
          on: {
            "update:value": function updateValue($event) {
              return _vm.$set(_vm.office, "vanityUrl", $event);
            }
          }
        })], 1), _c('FormItemGroup', [_c('FormItem', {
          attrs: {
            "label": "Web Admin",
            "value": _vm.selectedWebAdminId,
            "edit-mode": "",
            "disabled": _vm.submitting,
            "edit-select-values": _vm.eligibleWebAdmins,
            "tooltip-text": "The Website Admin designation grants this user access to the main office website admin settings.  Only one user may be designated as the Website Admin at this time."
          },
          on: {
            "update:value": function updateValue($event) {
              _vm.selectedWebAdminId = $event;
            }
          }
        })], 1), _c('FormItemGroup', [_c('FormItem', {
          attrs: {
            "label": "ORM Business Description",
            "value": _vm.office.locationDetails,
            "edit-mode": "",
            "textarea": "",
            "options": {
              hideAsterisk: true
            },
            "disabled": _vm.submitting,
            "tooltip-text": "This description appears on the main office website in the About Us section, and on listings such as Google My Business. ",
            "rules": 'required|max:750'
          },
          on: {
            "update:value": function updateValue($event) {
              return _vm.$set(_vm.office, "locationDetails", $event);
            }
          }
        })], 1), _c('FormItemGroup', [_c('FormItem', {
          attrs: {
            "label": "Short Web Description",
            "value": _vm.office.shortDescription,
            "rules": "max:100",
            "edit-mode": "",
            "disabled": _vm.submitting,
            "tooltip-text": "Add a short description of your business that will appear across the web where a short business description is available with your populated information.  Limit is 100 characters."
          },
          on: {
            "update:value": function updateValue($event) {
              return _vm.$set(_vm.office, "shortDescription", $event);
            }
          }
        })], 1)], 1) : _vm._e(), _vm.form === 'request_licenses' ? _c('div', [_c('div', [_c('div', [_c('FormItemGroup', [_c('PersonnelFormLicenseStates', {
          attrs: {
            "label": "State(s) of Licensure",
            "edit-mode": "",
            "rules": 'required',
            "edit-select-values": _vm.availableStates,
            "disabled": !_vm.office.canAddMoreLicenses || _vm.submitting,
            "placeholder": 'Select...',
            "read-only-values": _vm.office.originalLicenses,
            "value": _vm.office.licenses
          },
          on: {
            "update:value": function updateValue($event) {
              return _vm.$set(_vm.office, "licenses", $event);
            }
          }
        })], 1)], 1), _c('AdditionalLoPhaseTwoLicensesForm', {
          ref: "loPhaseTwoLicensesForm",
          attrs: {
            "phase-two-users": _vm.loPhaseTwoUsers,
            "submitting": _vm.submitting,
            "license-states": _vm.additionalLoPhaseTwoLicenseStates
          }
        })], 1)]) : _vm._e()]) : _vm._e()])];
      }
    }])
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }